import {gql} from '@apollo/client';

export const exchangeRatesFetch = gql`
  query ExchangeRatesFetch {
    exchangeRates {
      _id
      value
      sourceCurrency
      targetCurrency
      validFrom
      validTo
    }
  }
`;
